import {combineEpics} from "redux-observable";
import {
    fetchProjectLogEpic,
    fetchProjectLogEntryThreadEpic,
    updateProjectLogEntryEpic,
    restoreProjectLogEntryEpic,
    deleteProjectLogEntryEpic,
    createProjectLogEntryEpic,
    markProjectLogEntryReadEpic
} from "./projects/ProjectLogActions";
import { eventNotificationEpic } from "./common/EventNotificationActions";
import { fetchMenuItemsEpic} from "./menu/MainMenuActions";
import {
    fetchAuthenticatedUserEpic,
    userLoginEpic,
    userLogoutEpic,
    userRefreshEpic
} from "./common/AuthenticatedUserActions";
import {fetchUnreadNotificationsCountEpic, fetchUserNotificationUnreadEpic, markUserNotificationAsReadEpic} from "./user/NotificationActions";
import {
    fetchUserGroupsEpic,
    saveUserGroupFormEpic,
    deleteUserGroupEpic,
    fetchUserGroupsByUserEpic, fetchUserGroupEpic
} from "./user-groups/UserGroupsActions";
import {
    createUserViewSettingsEpic, deleteUserViewSettingsEpic, fetchTopUserViewSettingsEpic,
    fetchUserViewSettingsEpic,
    handleSearchEpic,
    incrementViewSettingsUsageCountEpic, replaceUserViewSettingsEpic
} from "./common/UserViewSettingsActions";
import { fetchUserGroupsAreasEpic, fetchUserGroupAreaViewsEpic } from "./user-groups/UserGroupAreasActions";
import {
    fetchEmployeeEpic,
    fetchEmployeesEpic,
    createEmployeeEpic,
    checkEmailUniquenessEpic,
    deleteEmployeeEpic, restoreEmployeeEpic, updateEmployeeEpic
} from "./employees/EmployeeActions";
import {fetchEmployersOfficesEpic} from "./employees/EmployersOfficeActions";
import {
    createEmployerEpic, deleteEmployerEpic,
    fetchEmployerByIdEpic,
    fetchEmployersEpic, restoreEmployerEpic, updateEmployerEpic
} from "./employees/EmployerActions";
import {fetchHelpEpic} from "./common/HelpActions";
import {
    createTimesheetEntryEpic, deleteTimesheetEntryEpic, fetchSeriesAppointmentsEpic,
    fetchTimesheetEntriesEpic,
    fetchTimesheetEntryEpic, importTimesheetEntryEpic, restoreTimesheetEntryEpic, updateTimesheetEntryEpic
} from "./timesheet/TimesheetActions";
import {createProjectEpic, fetchProjectByIdEpic, fetchProjectsEpic, updateProjectEpic} from "./projects/ProjectActions";
import {fetchProjectStagesEpic} from "./projects/ProjectStageActions";
import {
    fetchProjectPhaseNextIdEpic,
    fetchProjectStagePhasesEpic,
    updatePhasePerformanceEpic
} from "./projects/ProjectStagePhaseActions";
import {fetchInitialSelectOptionsEpic, fetchSelectOptionsEpic} from "./common/SelectActions";
import {
    fetchMenuTimesheetHoursReportEpic,
    fetchTimesheetHoursReportEpic,
    fetchTimesheetHoursReportExport, fetchTimesheetHoursReportExportEpic
} from "./reporting/TimesheetReportActions";
import {
    createTimesheetTaskEpic,
    deleteTimesheetTaskEpic,
    fetchTimesheetTaskEpic, fetchTimesheetTasksEpic, restoreTimesheetTaskEpic, updateTimesheetTaskEpic
} from "./timesheet_tasks/TimesheetTasksActions";
import {
     createTimesheetTaskPredefDescriptionEpic,
    deleteTimesheetTaskPredefDescriptionEpic,
    fetchTimesheetTaskPredefDescriptionEpic,
    restoreTimesheetTaskPredefDescriptionEpic,
    updateTimesheetTaskPredefDescriptionEpic
} from "./timesheet_tasks/TimesheetTaskPredefDescriptionActions";
import {
    createProjectLogTagEpic, deleteProjectLogTagEpic,
    fetchProjectLogTagsEpic,
    restoreProjectLogTagEpic, updateProjectLogTagEpic
} from "./projects/ProjectLogTagActions";
import {
    createProjectLogCategoryEpic, deleteProjectLogCategoryEpic,
    fetchProjectLogCategoriesEpic, restoreProjectLogCategoryEpic, updateProjectLogCategoryEpic
} from "./projects/ProjectLogCategoryActions";
import {
    createProjectRoleEpic, deleteProjectRoleEpic,
    fetchProjectRoleByIdEpic,
    fetchProjectRolesEpic, restoreProjectRoleEpic,
    updateProjectRoleEpic
} from "./projects/ProjectRoleActions";
import {
    createProjectCommissionStateEpic, deleteProjectCommissionStateEpic, fetchProjectCommissionStateByIdEpic,
    fetchProjectCommissionStateEpic, restoreProjectCommissionStateEpic, updateProjectCommissionStateEpic
} from "./project-commission-state/ProjectCommissionStateActions";
import {
    createQualificationEpic,
    deleteQualificationEpic,
    fetchQualificationByIdEpic,
    fetchQualificationsEpic,
    restoreQualificationEpic,
    updateQualificationEpic
} from "./qualifications/QualificationActions";
import {
    createCustomerEpic, deleteCustomerEpic,
    fetchCustomerByIdEpic,
    fetchCustomersEpic, restoreCustomerEpic,
    updateCustomerEpic
} from "./customers/CustomerActions";
import {
    createCustomerOfficeEpic, deleteCustomerOfficeEpic,
    fetchCustomerOfficeByIdEpic,
    fetchCustomerOfficesEpic, restoreCustomerOfficeEpic, updateCustomerOfficeEpic
} from "./customers/CustomerOfficeActions";
import {
    createCustomerContactEpic, deleteCustomerContactEpic,
    fetchCustomerContactByIdEpic,
    fetchCustomerContactsEpic, restoreCustomerContactEpic, updateCustomerContactEpic
} from "./customers/CustomerContactActions";
import {createContractorEpic, deleteContractorEpic, fetchContractorByIdEpic, fetchContractorsEpic,
    restoreContractorEpic, updateContractorEpic} from "./contractors/ContractorActions";
import {fetchContractedWorksEpic} from "./contractors/ContractedWorkActions";
import {   fetchContractorContactsEpic} from "./contractors/ContractorContactActions";
import {fetchContractorOfficesEpic} from "./contractors/ContractorOfficeActions";
import {
    createExternalWorkEpic, deleteExternalWorkEpic,
    fetchExternalWorkByIdEpic,
    fetchExternalWorksEpic, generateExternalWorkTasksEpic, restoreExternalWorkEpic, updateExternalWorkEpic
} from "./contractors/ExternalWorkActions";
import {createExternalWorkGroupEpic,
    deleteExternalWorkGroupEpic, fetchExternalWorkGroupByIdEpic, fetchExternalWorkGroupsEpic, updateExternalWorkGroupEpic,
restoreExternalWorkGroupEpic } from './contractors/ExternalWorkGroupActions';
import {
    fetchCalendarEntriesEpic,
    fetchHolidaysEpic,
    fetchMandatoryWorkhoursEpic,
    fetchWorkdaysEpic
} from "./calendar/CalendarActions";
import {
    fetchProjectEmployeesEpic,
    fetchProjectStageEmployeesEpic,
    fetchProjectStagePhaseEmployeesEpic
} from "./projects/ProjectStagePhaseEmployeeActions";
import {fetchProjectPrivilegesEpic} from "./projects/ProjectPrivilegesActions";
import {fetchProjectTimesheetEpic, fetchProjectTimesheetReportExportEpic} from "./projects/ProjectTimesheetActions";
import {projectContractorNextIdEpic} from "./projects/ProjectContractorActions";
import {downloadFileEpic} from "./common/FileActions";

import {
    createOutgoingInvoiceEpic,
    fetchOutgoingInvoicesCheckFinalEpic,
    fetchOutgoingInvoicesEpic,
    deleteOutgoingInvoiceByIdEpic,
    fetchOutgoingInvoicesNextSerialEpic, fetchOutgoingInvoicesPrePaymentByProjectEpic,
    fetchOutgoingInvoiceByIdEpic, markCanceledOutgoingInvoiceEpic, markFinalizedOutgoingInvoiceEpic,
 fetchOutInvoiceFilesByIdEpic, updateOutgoingInvoiceEpic
} from "./account-book/AccountBookActions";
import {
    insertOutgoingInvoicePaymentEpic,
    deleteOutgoingInvoicePaymentEpic
} from "./account-book/OutgoingInvoicePaymentActions";
import {fetchOutgoingInvoicesProjectLogEpic} from "./account-book/OutgoingInvoiceProjectLogActions";
import {
    fetchProjectPhaseTaskNextIdEpic, updateMultipleTaskPerformances, updateMultipleTaskPerformancesEpic,
    updatePhaseTaskPerformanceEpic
} from "./projects/ProjectStagePhaseTaskActions";
import {fetchOutInvoiceProjectTaskTimeItemEpic} from "./account-book/OutInvoiceProjectTaskTimeItemActions";
import {
    createIncomingInvoiceEpic, deleteIncomingInvoiceByIdEpic,
    fetchIncomingInvoiceByIdEpic,
    fetchIncomingInvoicesCheckFinalEpic,
    fetchIncomingInvoicesEpic,
    fetchIncomingInvoicesPrePaymentByProjectEpic, fetchInInvoiceFilesByIdEpic,
    markCanceledIncomingInvoiceEpic,
    markFinalizedIncomingInvoiceEpic,
    updateIncomingInvoiceEpic
} from "./incoming-invoice/IncomingInvoiceActions";
import {
    deleteIncomingInvoicePaymentEpic,
    insertIncomingInvoicePaymentEpic
} from "./incoming-invoice/IncomingInvoicePaymentActions";
import {fetchInInvoicePhaseTaskItemEpic} from "./incoming-invoice/IncomingInvoicePhaseTaskItemActions";
import {fetchIncomingInvoicesProjectContractorEpic} from "./incoming-invoice/IncomingInvoiceProjectContractorActions";
import {fetchIncomingInvoicesProjectLogEpic} from "./incoming-invoice/IncomingInvoiceProjectLogActions";
import {
    createProjectAppendixEpic,
    deleteProjectAppendixEpic,
    fetchNextProjectAppendixNumberEpic,
    fetchProjectAppendixByIdEpic,
    fetchProjectAppendixEpic,
    updateProjectAppendixEpic
} from "./projects/ProjectAppendixActions";
import {fetchProjectReportEpic, fetchProjectReportExportEpic} from "./reporting/ProjectReportActions";
import {persistProjectEmployeeEpic} from "./projects/ProjectEmployeeActions";
import {updateUserAttendanceTimeEpic, fetchUserAttendanceTimeEpic} from "./timesheet/UserAttendanceTimeActions";
import {
    fetchProjectSolvencyReportByProjectEpic,
    fetchProjectSolvencyReportEpic,
    fetchProjectSolvencyReportExportEpic
} from "./reporting/ProjectSolvencyReportActions";
import {fetchProjectMetaEpic, fetchTradePartnersEpic } from "./account-book/OutgoingInvoiceTemplateActions";
import {fetchOutInvoiceProjectTaskFlatItemEpic} from "./account-book/OutInvoiceProjectTaskFlatItemActions";
import {aiSendUserMessageEpic} from "./ai/AiChatBotActions";
import {createTeamEpic, fetchTeamByIdEpic, updateTeamEpic, fetchTeamsEpic } from "./projects/TeamActions";
import {registerTenantEpic} from "./register/RegisterActions";
import {
    createUserApiKeyEpic,
    deleteUserApiKeyEpic,
    fetchUserApiKeyEpic,
    fetchUserApiKeysEpic
} from "./api-keys/ApiKeysActions";


/**
 * route index of all redux-observable epics in the system
 *
 * @type {*}
 */
/*export const RootEpic = (
    action$: any,
    state$: StateObservable< AppState >
) => merge(*/
//@ts-ignore
export const RootEpic = combineEpics(
    /* tenant registration */
    registerTenantEpic,
    /* EventNotification */
    //@ts-ignore
    eventNotificationEpic,
    /* UserGroup */
    saveUserGroupFormEpic,
    deleteUserGroupEpic,
    fetchUserGroupsEpic,
    fetchUserGroupsByUserEpic,
    fetchUserGroupEpic,
    fetchUserViewSettingsEpic,
    /* UserGroupArea */
    fetchUserGroupsAreasEpic,
    fetchUserGroupAreaViewsEpic,
    /* AuthenticatedUser / User */
    userLoginEpic,
   userRefreshEpic,
   // userLogoutEpic,
    fetchAuthenticatedUserEpic,
    fetchUnreadNotificationsCountEpic,
    fetchUserNotificationUnreadEpic,
    markUserNotificationAsReadEpic,
    fetchMenuItemsEpic,
    /* Employee */
    fetchEmployeesEpic,
    fetchEmployeeEpic,
    createEmployeeEpic,
    updateEmployeeEpic,
    checkEmailUniquenessEpic,
    deleteEmployeeEpic,
    restoreEmployeeEpic,
    /* Employer */
    fetchEmployersOfficesEpic,
    fetchEmployersEpic,
    fetchEmployerByIdEpic,
    createEmployerEpic,
    updateEmployerEpic,
    deleteEmployerEpic,
    restoreEmployerEpic,
    /* Employee Qualifications */
    /* Help */
    fetchHelpEpic,
    /* Project */
    fetchProjectsEpic,
    fetchProjectByIdEpic,
    createProjectEpic,
    updateProjectEpic,
    fetchProjectTimesheetEpic,
    fetchProjectTimesheetReportExportEpic,
    /* ProjectStage */
    fetchProjectStagesEpic,
    /* ProjectStagePhase */
    fetchProjectStagePhasesEpic,
    updatePhasePerformanceEpic,
    fetchProjectPhaseNextIdEpic,
    /* SelectOption */
    fetchSelectOptionsEpic,
    fetchInitialSelectOptionsEpic,
    /* TimesheetEntry */
    fetchTimesheetEntriesEpic,
    createTimesheetEntryEpic,
    fetchTimesheetEntryEpic,
    fetchSeriesAppointmentsEpic,
    restoreTimesheetEntryEpic,
    updateTimesheetEntryEpic,
    deleteTimesheetEntryEpic,
    importTimesheetEntryEpic,
    /* TimesheetTask */
    fetchTimesheetTaskEpic,
    fetchTimesheetTasksEpic,
    deleteTimesheetTaskEpic,
    restoreTimesheetTaskEpic,
    updateTimesheetTaskEpic,
    createTimesheetTaskEpic,
    /* Reporting */
    fetchTimesheetHoursReportEpic,
    fetchMenuTimesheetHoursReportEpic,
    fetchProjectReportExportEpic,
    /* UserViewSettings */
    incrementViewSettingsUsageCountEpic,
    createUserViewSettingsEpic,
    replaceUserViewSettingsEpic,
    deleteUserViewSettingsEpic,
    fetchTopUserViewSettingsEpic,
    handleSearchEpic,
    /* TimesheetTask predefined description */
    fetchTimesheetTaskPredefDescriptionEpic,
    deleteTimesheetTaskPredefDescriptionEpic,
    updateTimesheetTaskPredefDescriptionEpic,
    restoreTimesheetTaskPredefDescriptionEpic,
    createTimesheetTaskPredefDescriptionEpic,
    /* ProjectLogTag */
    fetchProjectLogTagsEpic,
    createProjectLogTagEpic,
    deleteProjectLogTagEpic,
    restoreProjectLogTagEpic,
    updateProjectLogTagEpic,
    /* ProjectLogCategory */
    fetchProjectLogCategoriesEpic,
    createProjectLogCategoryEpic,
    updateProjectLogCategoryEpic,
    deleteProjectLogCategoryEpic,
    restoreProjectLogCategoryEpic,
    /* ProjectLogEntry */
    fetchProjectLogEpic,
    createProjectLogEntryEpic,
    updateProjectLogEntryEpic,
    deleteProjectLogEntryEpic,
    restoreProjectLogEntryEpic,
    markProjectLogEntryReadEpic,
    fetchProjectLogEntryThreadEpic,
    /* ProjectRole */
    fetchProjectRolesEpic,
    fetchProjectRoleByIdEpic,
    createProjectRoleEpic,
    updateProjectRoleEpic,
    deleteProjectRoleEpic,
    restoreProjectRoleEpic,
    /* ProjectCommissionState */
    createProjectCommissionStateEpic,
    fetchProjectCommissionStateEpic,
    updateProjectCommissionStateEpic,
    deleteProjectCommissionStateEpic,
    restoreProjectCommissionStateEpic,
    fetchProjectCommissionStateByIdEpic,
    /* ProjectStagePhaseEmployee */
    fetchProjectStagePhaseEmployeesEpic,
    fetchProjectEmployeesEpic,
    fetchProjectStageEmployeesEpic,
    /* ProjectContractor */
    projectContractorNextIdEpic,
    /* ProjectPrivileges */
    fetchProjectPrivilegesEpic,
    /* ProjectStagePhaseTask */
    updatePhaseTaskPerformanceEpic,
    fetchProjectPhaseTaskNextIdEpic,
    updateMultipleTaskPerformancesEpic,
    /* Qualification */
    fetchQualificationsEpic,
    fetchQualificationByIdEpic,
    createQualificationEpic,
    updateQualificationEpic,
    deleteQualificationEpic,
    restoreQualificationEpic,
    /* customers */
    fetchCustomersEpic,
    fetchCustomerByIdEpic,
    createCustomerEpic,
    updateCustomerEpic,
    deleteCustomerEpic,
    restoreCustomerEpic,
    /* customer office */
    fetchCustomerOfficesEpic,
    fetchCustomerOfficeByIdEpic,
    createCustomerOfficeEpic,
    updateCustomerOfficeEpic,
    deleteCustomerOfficeEpic,
    restoreCustomerOfficeEpic,
    /* customer contacts */
    fetchCustomerContactsEpic,
    fetchCustomerContactByIdEpic,
    createCustomerContactEpic,
    updateCustomerContactEpic,
    deleteCustomerContactEpic,
    restoreCustomerContactEpic,
    /* contractors */
    fetchContractorsEpic,
    fetchContractorByIdEpic,
    createContractorEpic,
    updateContractorEpic,
    deleteContractorEpic,
    restoreContractorEpic,
    /* contracted works */
    fetchContractedWorksEpic,
    /* contractor contacts */
    fetchContractorContactsEpic,
    /* contractor offices */
    fetchContractorOfficesEpic,
    /* external work */
    fetchExternalWorksEpic,
    fetchExternalWorkByIdEpic,
    createExternalWorkEpic,
    updateExternalWorkEpic,
    deleteExternalWorkEpic,
    restoreExternalWorkEpic,
    generateExternalWorkTasksEpic,
    /* external work group */
    fetchExternalWorkGroupsEpic,
    fetchExternalWorkGroupByIdEpic,
    createExternalWorkGroupEpic,
    updateExternalWorkGroupEpic,
    deleteExternalWorkGroupEpic,
    restoreExternalWorkGroupEpic,
    /* calendar */
    fetchCalendarEntriesEpic,
    fetchHolidaysEpic,
    fetchWorkdaysEpic,
    fetchMandatoryWorkhoursEpic,
    /* file */
    downloadFileEpic,
    /* accounting */
    fetchOutgoingInvoicesEpic,
    fetchOutgoingInvoicesNextSerialEpic,
    fetchOutgoingInvoicesPrePaymentByProjectEpic,
    createOutgoingInvoiceEpic,
    fetchOutgoingInvoicesCheckFinalEpic,
    fetchOutgoingInvoiceByIdEpic,
    markCanceledOutgoingInvoiceEpic,
    markFinalizedOutgoingInvoiceEpic,
    insertOutgoingInvoicePaymentEpic,
    deleteOutgoingInvoicePaymentEpic,
    fetchOutInvoiceFilesByIdEpic,
    updateOutgoingInvoiceEpic,
    deleteOutgoingInvoiceByIdEpic,
    fetchOutInvoiceProjectTaskTimeItemEpic,
    fetchTradePartnersEpic,
    fetchOutInvoiceProjectTaskFlatItemEpic,
    fetchProjectMetaEpic,
    /* outgoing invoice log */
    fetchOutgoingInvoicesProjectLogEpic,
    /* incoming invoice */
    fetchIncomingInvoicesEpic,
    fetchIncomingInvoicesPrePaymentByProjectEpic,
    createIncomingInvoiceEpic,
    fetchIncomingInvoicesCheckFinalEpic,
    fetchIncomingInvoiceByIdEpic,
    markCanceledIncomingInvoiceEpic,
    markFinalizedIncomingInvoiceEpic,
    insertIncomingInvoicePaymentEpic,
    deleteIncomingInvoicePaymentEpic,
    fetchInInvoiceFilesByIdEpic,
    updateIncomingInvoiceEpic,
    deleteIncomingInvoiceByIdEpic,
    fetchInInvoicePhaseTaskItemEpic,
    fetchIncomingInvoicesProjectContractorEpic,
    fetchIncomingInvoicesProjectLogEpic,
    /* project appendix */
    fetchProjectAppendixEpic,
    fetchProjectAppendixByIdEpic,
    createProjectAppendixEpic,
    updateProjectAppendixEpic,
    deleteProjectAppendixEpic,
    fetchNextProjectAppendixNumberEpic,
    /* project employee */
    persistProjectEmployeeEpic,
    /* team */
    fetchTeamsEpic,
    fetchTeamByIdEpic,
    createTeamEpic,
    updateTeamEpic,
    /* reporting */
    fetchProjectReportEpic,
    fetchProjectSolvencyReportEpic,
    fetchProjectSolvencyReportByProjectEpic,
    fetchTimesheetHoursReportExportEpic,
    fetchProjectSolvencyReportExportEpic,
    /* user attendance time */
    updateUserAttendanceTimeEpic,
    fetchUserAttendanceTimeEpic,
    /* AI */
    aiSendUserMessageEpic,
    /* api keys*/
    fetchUserApiKeysEpic,
    createUserApiKeyEpic,
    fetchUserApiKeyEpic,
    deleteUserApiKeyEpic
);